import { render, staticRenderFns } from "./EditPackagingDialog.vue?vue&type=template&id=5a16747d&scoped=true"
import script from "./EditPackagingDialog.vue?vue&type=script&lang=js"
export * from "./EditPackagingDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPackagingDialog.vue?vue&type=style&index=0&id=5a16747d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16747d",
  null
  
)

export default component.exports